import { oidc } from "services/oidcService";

const getHeaders = async requestInfo => {
  const headers = new Headers({
    "Content-Type": "application/json",
    "Cache-Control": "no-cache"
  });

  if (requestInfo && requestInfo.includeToken) {
    headers.append("Authorization", `Bearer ${await oidc.getOidcManager().getAccessToken()}`);
  }

  if (requestInfo && requestInfo.correlationId) {
    headers.append("X-CorrelationId", requestInfo.correlationId);
  }

  return headers;
};

const checkResponse = async res => {
  if (!res.ok) {
    throw new Error(await res.text());
  }

  return res.text();
};

const parseToJson = text => (text.length ? JSON.parse(text) : "");

const rawRequest = async (requestInfo = null, method = "GET", path = "", payload = null) => {
  const options = {
    method,
    headers: await getHeaders(requestInfo),
    mode: "cors",
    responseType: "application/json",
    cache: "default"
  };

  if (payload) {
    options.body = JSON.stringify(payload);
  }

  return fetch(path, options);
};

const request = (requestInfo = null, method = "GET", path = "", payload = null, parseResponse = true) => {
  return rawRequest(requestInfo, method, path, payload)
    .then(checkResponse)
    .then(parseResponse ? parseToJson : res => res);
};

export const GET = (requestInfo, path) => request(requestInfo, "GET", path, null);
export const POST = (requestInfo, path, payload) => request(requestInfo, "POST", path, payload);
export const PATCH = (requestInfo, path, payload) => request(requestInfo, "PATCH", path, payload);
export const PUT = (requestInfo, path, payload) => request(requestInfo, "PUT", path, payload);
export const DELETE = (requestInfo, path) => request(requestInfo, "DELETE", path, null);

export const rawGET = (requestInfo, path) => rawRequest(requestInfo, "GET", path, null);
export const rawPOST = (requestInfo, path, payload) => rawRequest(requestInfo, "POST", path, payload);
export const rawPATCH = (requestInfo, path, payload) => rawRequest(requestInfo, "PATCH", path, payload);
export const rawPUT = (requestInfo, path, payload) => rawRequest(requestInfo, "PUT", path, payload);
export const rawDELETE = (requestInfo, path) => rawRequest(requestInfo, "DELETE", path, null);
